<template>
  <QS-scroller-box>
    <TopPreview
      :dataList="topPreviewModelList"
      :model="topPreviewModel"
    />
    <QS-h4-title title="发车前收款信息">
      <template #content>
        <div style="color: #ff9c2a">
          <i class="QS-icon-info"></i>
          <span>请根据业务实际情况进行收款，也可以直接跳过本步骤，立即发车。</span>
        </div>
      </template>
    </QS-h4-title>
    <div>
      <div>
        <el-button
          type="primary"
          :disabled="batchOfflineCollectAble"
          @click="batchOfflineCollect"
        >
          批量线下收款
        </el-button>
        <i class="cut-off"></i>
        <el-button @click="
            () => {
              showOrderReceiptDialog = true
              $refs.orderReceiptList && $refs.orderReceiptList.fetchReceiptList && $refs.orderReceiptList.fetchReceiptList()
            }
          "
        >订单收款记录</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="reloadState"
        >
          刷新收款状态
        </el-button>
      </div>
      <!-- 收款信息列表 -->
      <!-- eslint-disable-next-line vue/no-unused-refs -->
      <QS-common-table ref="receiptBLMCommonTable"
        :header-cell-class-name="cellClass"
        v-loading="receiptLoading"
        :columns="c_receiptColumns"
        :pagination="receiptPagination"
        :data="receiptData"
        @change="receiptTableChange"
        @select="selectionChangeEventForOverdue"
        @select-all="selectionAllChangeEventForOverdue"
      />
    </div>
    <!-- 订单收款记录弹窗 -->
    <dialogWrap
      v-model="showOrderReceiptDialog"
      :width="'824px'"
      title="订单收款记录"
    >
      <orderReceiptList
        ref="orderReceiptList"
        @revokeSuccess="revokeSuccess"
        @closeDialog="showOrderReceiptDialog = false"
      />
    </dialogWrap>
    <template slot="bottomAction">
      <el-button
        @click="cancel"
        size="mini"
      >取消</el-button>
      <el-button
        @click="confirm"
        :loading="loading"
        size="mini"
        type="primary"
      >跳过收款，立即发车</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
// api
import {
  leaseContractOrderDetail,
  getPaymentMethods,
} from '@/api/purchaseAndSaleAPI'
import { getReceivableList } from '@/api/financeApi'
import { skipPayment } from '@/api/domain/orders'
// 组件
import TopPreview from '../components/TopPreview'
import orderReceiptList from '../components/orderReceiptList'
// 配置
// eslint-disable-next-line import/no-cycle
import publicConfig from '../config'
import config from './config/orderPayment'
// 其他
import selectOption from '@/store/dict/selectOptionDict'
import { batchOfflineCollectCheck, overdueUtils } from '@/pages/utils/overdue'

export default {
  components: {
    TopPreview,
    orderReceiptList,
  },
  props: {
    topPreviewModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const {
      c_receiptColumns,
    } = config.call(this)
    const { selectionAllChangeEventForOverdue, selectionChangeEventForOverdue, ifOfflineOverdueItem } = overdueUtils.call(this)
    return {
      selectionAllChangeEventForOverdue,
      selectionChangeEventForOverdue,
      ifOfflineOverdueItem,
      c_receiptColumns,
      // 是否展示收款记录弹窗
      showOrderReceiptDialog: false,
      receiptLoading: false,
      // 收款数据
      receiptData: [],
      // 收款--分页
      receiptPagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      loading: false,
      // 收款被选中项
      receiptSelectedItems: [],
      // 收款项枚举
      freeTypeList: [],
    }
  },
  computed: {
    batchOfflineCollectAble() {
      return !this.receiptSelectedItems.length
    },
    // 顶部预览数据
    topPreviewModelList() {
      const { c_topPreviewList } = publicConfig.call(this)
      return c_topPreviewList
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    // 刷新收款状态
    reloadState() {
      this.loading = true
      leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      }).then((res) => {
        const { code, data } = res
        const { state } = data
        if (code === 1 && state === 1500) {
          this.$message({
            message: '发车前收款项已全部收款完成，将自动自动下一步',
            type: 'success',
            duration: 2000,
          })
          const timer = setTimeout(() => {
            this.$router.replace({
              path: '/car_to_lease/forRentSignContract/personalSignContract',
              query: {
                orderId: this.topPreviewModel.orderId,
              },
            })
            clearTimeout(timer)
          }, 2000)
        }
        this.loading = false
      })
      this.getReceivableList()
    },
    // 执行线下收款
    // eslint-disable-next-line vue/no-unused-properties
    offlineReceipt({ id, relReceivableState }) {
      // 对新滞纳金线下收款逻辑
      if (this.ifOfflineOverdueItem(relReceivableState)) {
        return
      }
      const query = {
        type: 'order',
        paymentIds: id,
        // 1: '应收列表线下收款',2: '应收列表批量线下收款',3: '个人订单详情线下收款',4: '个人订单详情批量线下收款',
        // 5: '企业租赁订单详情线下收款',6: '企业租赁订单详情批量线下收款',7: '催收预提醒线下收款',8: '催收逾期线下收款',
        // 9: '采购订单详情线下收款',10: '采购订单详情批量线下收款'
        approvalOrigin: 5,
      }
      // 进行页面跳转
      this.$router.push({
        path: '/workbench/batchCollectionRecordAdd',
        query,
      })
    },
    revokeSuccess() {
      this.getReceivableList()
    },
    // 应收分页事件
    receiptTableChange(payload) {
      this.receiptLoading = true
      this.receiptPagination.pageNum = payload.pagination.pageNum
      this.receiptPagination.pageSize = payload.pagination.pageSize
      this.getReceivableList()
    },
    // 应收列表
    async getReceivableList() {
      const { code, data } = await getReceivableList({
        advancePayment: 1, // 是否发车前收款 0否/1是
        sourceOrderId: this.topPreviewModel.orderId,
        pageNum: this.receiptPagination.pageNum,
        pageSize: this.receiptPagination.pageSize,
      })
      this.receiptLoading = false
      if (code === 1) {
        this.receiptData = data.items
          ? data.items.map((item) => {
            return {
              ...item,
              changeState: selectOption.payeechange[item.changeState],
              receivableState:
                selectOption.completionStatusDict[item.receivableState],
              content: this.formatEnumeration(this.freeTypeList)[item.content],
            }
          })
          : []
        this.receiptPagination.total = data.totalNum
      }
    },
    cellClass(row) {
      // 获取可选数据的条数的长度（剩余应收金额为0，item.remainAmount === 0 ）
      const len = this.receiptData.filter((item) => !(Number(item.remainAmount) === 0 || item.receivableState === '已完成' || item.receivableState === '已关闭')).length
      if (row.columnIndex === 0 && !len) {
        return 'disableSelection'
      }
    },
    // 批量线下收款能力
    batchOfflineCollect() {
      // 筛选出所有订单ID
      const idList = this.receiptSelectedItems.map((obj) => obj.id).join(',')
      batchOfflineCollectCheck(idList).then((res) => {
        if (res?.code === 1) {
          // 进行页面跳转
          this.$router.push({
            path: '/workbench/batchCollectionRecordAdd',
            query: {
              paymentIds: idList,
              type: 'order',
              approvalOrigin: 4,
            },
          })
        }
      })
    },
    // 获取详情
    getLeaseContractOrderDetail() {
      this.loading = true
      leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      }).then((res) => {
        const { data } = res
        if (data) {
          const {
            deptName,
            customerName,
            planName,
            modelName,
            plateNo,
            rentCategoryName,
            startDate,
            state,
            endDate,
            storeName,
            brandName,
            seriesName,
          } = data

          /* eslint-disable vue/no-mutating-props */
          this.topPreviewModel.deptName = deptName
          this.topPreviewModel.customerName = customerName
          this.topPreviewModel.planName = planName || '自定义'
          this.topPreviewModel.brandName = brandName
          this.topPreviewModel.seriesName = seriesName
          this.topPreviewModel.modelName = modelName
          this.topPreviewModel.rentCategoryName = rentCategoryName
          this.topPreviewModel.plateNo = plateNo
          this.topPreviewModel.startStopDate = `${startDate}至${endDate}`
          this.topPreviewModel.state = state
          this.topPreviewModel.storeName = storeName
          /* eslint-enable vue/no-mutating-props */
          if ([1500, 2500].includes(Number(state))) { // state:1500 发车验车;state:2500完成-签约提车完成（履约中)
            this.toNext(state)
          }
        }
        this.loading = false
      })
    },
    // 取消
    cancel() {
      this.$confirm('是否确认退出创建个人签约提车流程?退出后可在"待租车辆列表-个人租赁订单-订单待支付"状态下找到订单并继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$emit('cancel')
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => { })
    },

    // 下一步
    toNext(state) {
      if (Number(state) === 1500) { // state:1500  发车验车
        this.toVehicleInspection(4)
      } else if (Number(state) === 2500) { // state:2500 完成-签约提车完成（履约中）
        this.toVehicleInspection(5)
      }
    },

    // 跳转发车验车逻辑
    toVehicleInspection(stepsActive) {
      // stepsActive：跳转到第几步
      this.$router.replace({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query: {
          stepsActive,
          orderId: this.topPreviewModel.orderId,
        },
      })
    },

    // 查询签约提车流转状态
    async getOrderState() {
      this.loading = true
      const { data } = await leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      })
      this.loading = false
      return data
    },

    // 确认
    async confirm() {
      const data = await this.getOrderState()
      if (!data) {
        this.reloadState()
        return
      }
      if ([1500, 2500].includes(Number(data.state))) { // state:1500 发车验车;state:2500完成-签约提车完成（履约中)
        this.toNext(data.state)
      } else {
        this.loading = true
        skipPayment({
          orderId: this.topPreviewModel.orderId,
        }).then((res) => {
          const { code } = res
          if (code === 1) {
            this.toVehicleInspection(4)
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    // 获取收款项
    async getReceiveEnum() {
      const res = await getPaymentMethods({ type: 'financeFeeType' })
      if (res?.code === 1) {
        this.freeTypeList = res.data
      }
    },
    async init() {
      // 获取收款项
      await this.getReceiveEnum()
      // 获取详情
      this.getLeaseContractOrderDetail()
      // 获取应收列表
      this.getReceivableList()
    },
  },
}
</script>
<style lang="scss" scoped>
.cut-off {
  border-right: 1px solid #dcdee0;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
  margin: 0px 5px;
}
</style>
